import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'checkout_flash_offer';
export const route = 'checkout_flash_offer/[bookingId]/';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "flights_flash_offer_page" */
/* webpackPrefetch: true */
'../components/FlashOfferPage')));